import React from 'react'

import { TimelineSpan, TimelineSpanParent } from '../../domain/TimelineSpan'
import { getTraceSpanCategory, BottleneckIdentifications, TraceSpanCategory } from '../../domain/Trace'
import { TraceDetailsTitle } from '../tracedetails/TraceDetailsTitle'
import { TraceDetails } from '../tracedetails/TraceDetails'
import TraceDetailsSpan, { SpanTraceInfo } from '../tracedetails/TraceDetailsSpan'

interface OwnProps {
    wt: number
    span: TimelineSpan
    traceInfo?: SpanTraceInfo
    parents: TimelineSpanParent[]
    categories: { [category: string]: TraceSpanCategory }
    mc?: number
    route: string
    showSettingsLink: boolean
    bottleneckRoute: string
    operationId?: number
    bottleneckIdentifications?: BottleneckIdentifications
    isRoot?: boolean
    children?: React.ReactNode
    sectionBelowTitle?: React.ReactNode
}

type Props = OwnProps

interface State {
    showAllParents: boolean
}

export class Span extends React.Component<Props, State> {
    public static defaultProps = {
        parents: [],
        showSettingsLink: true,
        isRoot: false,
    }

    public state: State = {
        showAllParents: false,
    }

    public serializeProps() {
        return JSON.stringify({
            wt: this.props.wt,
            span: {
                ...this.props.span,
                e: [],
                events: [],
            },
            traceInfo: this.props.traceInfo,
            stackTrace: this.props.span.stack,
            categories: this.props.categories,
            mc: this.props.mc,
            route: this.props.route,
            showSettingsLink: this.props.showSettingsLink,
            bottleneckRoute: this.props.showSettingsLink,
        })
    }

    public render() {
        const span = this.props.span
        const { isRoot, sectionBelowTitle } = this.props

        return (
            <TraceDetails>
                <TraceDetailsTitle
                    isRoot={isRoot || false}
                    category={getTraceSpanCategory(span)}
                    name={span.name}
                    namespace={span.annotations?.namespace || undefined}
                    async={span.async}
                />
                {sectionBelowTitle}
                <TraceDetailsSpan
                    wt={this.props.wt}
                    mc={this.props.mc}
                    span={span}
                    categories={this.props.categories}
                    parents={this.props.parents}
                    route={this.props.route}
                    showSettingsLink={this.props.showSettingsLink}
                    bottleneckRoute={this.props.bottleneckRoute}
                    traceInfo={this.props.traceInfo}
                />
                {this.props.children}
            </TraceDetails>
        )
    }
}

export default Span
